import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store';

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

const DEFAULT_TITLE = 'Access point | no title';
router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

router.beforeEach((to, from, next) => {
  //let isAuthenticated = store.getters.isAuthenticated;
  let isAuthenticated = !!localStorage.getItem(Vue.Keys.TOKEN);
  if(to.matched.some(record => !record.meta.noAuth)) {
    if(!isAuthenticated) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath },
        query: { redirect: to.fullPath }
      })
    }else{
      let user = store.getters.User;
      if(to.meta.admin && user.usr_admin) {
        next()
      }else if(to.meta.adminServiceLines && user.usr_adminservicelines) {
        next()
      }else if(to.meta.admin || to.meta.adminServiceLines){
        next('home')
      }else{
        next()
      }
    }
  }else {
    next();
  }
})

export default router;
